import React, { useEffect, useState, useRef } from 'react';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { filterBy } from "@progress/kendo-data-query";
import { orderBy } from "@progress/kendo-data-query";
import '@progress/kendo-theme-default/dist/all.scss';
import './GeneralGridStyle.scss';
import CustomLockedCell from './customizedColumns/CustomLockedCell'
import useProfileData from '../services/ProfileDataService';
import CustomFilter from '../components/customizedFilters/CustomFilter';
import Loader from './Loader';
import Toast from './ToastNotification';
import { useMsal } from "@azure/msal-react";
import Modal from './Modal';
import { ExcelExport, ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { getCurrentLine, subscribeToCurrentLineChanges } from '../services/CurrentLineService';
import NewOrdersCellStyle from './customizedColumns/NewOrdersCellStyle';

import { SvgIcon } from "@progress/kendo-react-common";
import { xIcon } from "@progress/kendo-svg-icons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Form, Field, FormElement, FieldWrapper } from "@progress/kendo-react-form";
import { TextBox, NumericTextBox, TextArea, Input } from "@progress/kendo-react-inputs";
import { Error, Label } from "@progress/kendo-react-labels";
import { Button } from "@progress/kendo-react-buttons";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import useDebounce from "./../Utilities/useDebounce";
import SidePanel from './SidePanel';
import { READ_ONLY } from '../Utilities/constants';
import { useEmployeeRoleContext } from '../services/EmployeeRoleContext';
import { useNewOrdersData } from '../Helpers/Hooks/UseGetOrdersData';
import { GET_NEW_ORDERS_LIST } from '../Helpers/queries/GetOrdersList';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateDraftHoursEstimate } from '../Helpers/Hooks/DraftHoursQueries';
import { defaultColumnsNewOrders, getVisibleColumns } from '../Utilities/defaultColumnsDefinition';

const minValueValidator = (value) => (value >= 0 ? "" : "The value must be 0 or higher");

const NonNegativeNumericInput = (fieldRenderProps) => {
  const [toast, setToast] = useState(false);
  const [idtoast, setIdtoast] = useState(1);
  const { disabled2, validationMessage, visited, id, valid, label, ...others } = fieldRenderProps;  

  useEffect(() => {
    if (fieldRenderProps.modified == true && fieldRenderProps.value < 0) {
      setIdtoast(idtoast + 1);
      setToast({ showToast: false });
      setToast({ showToast: true, message: 'The value must be 0 or higher', type: 'error' });
    }
  }, [fieldRenderProps.validationMessage != ""]);

  return (
    <>
      {toast && <Toast key={idtoast} showToast={toast.showToast} message={toast.message} type={toast.type} />}
      <Label editorId={id} editorValid={valid} className={"k-form-label roboto-15-500"}>
        {label}
      </Label>
      <div className={"k-form-field-wrap"}>
        <NumericTextBox spinners={disabled2} {...others} />
      </div>
    </>
  );
};

export const requiredValidator = (value) =>
  value ? "" : "Error: This field is required.";

export const FormTextArea = (fieldRenderProps) => {
  const { validationMessage, touched, label, id, valid, hint, disabled, optional, ...others } = fieldRenderProps;
  const max = 500;

  return (
    <FieldWrapper>
      <Label editorId={id} className={"k-form-label roboto-15-500"}>
        {label}
      </Label>
      <div className={"k-form-field-wrap"}>
        <TextArea
          style={{ height: '65px' }}
          valid={valid}
          id={id}
          disabled={disabled}
          maxLength={max}
          rows={10}
          {...others}
        />
      </div>
    </FieldWrapper>
  );
};
const FormDatePicker = (fieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    wrapperStyle,
    hintDirection,
    value,
    ...others
  } = fieldRenderProps;
  // const showValidationMessage = touched && validationMessage;
  const labelId = label ? `${id}_label` : "";

  // Date validation with the local storage
  const fixedDate = new Date('Wed Dec 31 1969 18:00:00 GMT-0600 (GMT-06:00)');
  const truncateTime = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  };
  const isSameDate = (date1, date2) => {
    if (!date1 || !date2) return false; // Check if either date is null or undefined
    return truncateTime(date1).getTime() === truncateTime(date2).getTime();
  };
  const defaultValue = value == null || isSameDate(value, fixedDate) ? null : value;   // Check if value is null or undefined, or if the dates are the same

  return (
    <FieldWrapper style={wrapperStyle}>
      <Label
        id={labelId}
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
        className="k-form-label roboto-15-500"
      >
        {label}
      </Label>
      <div className={"k-form-field-wrap roboto-15-500"}>
        <DatePicker
          ariaLabelledBy={labelId}
          valid={valid}
          id={id}
          disabled={disabled}
          value = {defaultValue}
          {...others}
        />
        {/* {showValidationMessage && (
          <Error id={errorId}>{validationMessage}</Error>
        )} */}
      </div>
    </FieldWrapper>
  );
};

const EditForm = props => {
  const {
    cancelEdit,
    onSubmit,
    item,
    ...other
  } = props;
  return (
    <FormElement>
      <div style={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
        <FieldWrapper>
          <Field width={100} name={"draftingHrs"} component={NonNegativeNumericInput} label={"Drafting HRS"} validator={minValueValidator} />
        </FieldWrapper>
        <Field
          id={"gdate"}
          name={"gdate"}
          label={"Earliest drafting completion"}
          component={FormDatePicker}
        // validator={requiredValidator}
        />
        <Field
          id={"endate"}
          name={"endate"}
          label={"Earliest Eng. completion"}
          component={FormDatePicker}
        // validator={requiredValidator}
        />
      </div>
      <FieldWrapper>
        <Field name={"ProductName"} component={FormTextArea} label={"Additional assembly time"} />
      </FieldWrapper>
      {/* </FormElement> */}
      <div style={{ marginTop: '24px', marginBottom: '-24px' }}>
        <DialogActionsBar layout="end">
          <Button className='secondary-button blue-text roboto-15-500'
            onClick={cancelEdit}>
            Close
          </Button>
          <Button
            className='primary-button roboto-15-500'
            type={"submit"}
            themeColor={"primary"}
          // disabled={!submit}
          >
            Save
          </Button>
        </DialogActionsBar>
      </div>
    </FormElement>
  );

};

const NewOrdersGrid = ({ columns = [], dateRange,
  filter, setFilter,
  prevFilter, setPrevFilter,
  currentFilter, setCurrentFilter, onRemoveAll,
  setRemoveFilter, dropdownFilters, setDropdownFilters, removeFilter, disabled,
  exportExcel, setExportExcel, CodeStringFilters, setCodeitemsChipsData, setScheduleData
}) => {
  
  const [users, setUsers] = useState([]);  

  const storedCurrentPage = localStorage.getItem('currentPageNewOrdView');
  const storedPage = localStorage.getItem('pageNewOrdView');

  const [pageSize, setPageSize] = useState(storedPage ? JSON.parse(storedPage).take : 50);
  const [sort, setSort] = useState([{ field: "SO", dir: "desc" }]);
  const [page, setPage] = useState(
    {
      skip: storedPage ? JSON.parse(storedPage).skip : 0,
      take: storedPage ? JSON.parse(storedPage).take : pageSize
    });


  const { token } = useProfileData(false);
  const queryClient = useQueryClient();
  const [currentPage, setCurrentPage] = useState(storedCurrentPage ? JSON.parse(storedCurrentPage) : 1);
  const [totalRows, setTotalRows] = useState(0);
  const [department, setDepartment] = useState(getCurrentLine().ProdFamilyId);

  const [toast, setToast] = useState(null);
  const [idtoast, setIdtoast] = useState(1);
  const viewAlias = 2;
  const [productName, setProductName] = useState(getCurrentLine().ProdFamilyName);
  const debouncedFilter = useDebounce(filter, "600");
  const dateColumn = 'BuildWeek'; 
  const [isRefreshing, setIsRefreshing] = useState(false);

  const storedCurrentNewOrders = localStorage.getItem('newOrdersExtrFields');
  const [newOrdersExInfo, setNewOrdersExInfo] = useState(storedCurrentNewOrders ? JSON.parse(storedCurrentNewOrders) : []);  

  const fetchData = async () => {
    setIsRefreshing(true);
    await refetch();    
    setIsRefreshing(false);
  };

  useEffect(() => {
    localStorage.setItem('filtersGeneralView', JSON.stringify(filter, null, 2));
    const sotredFilters = JSON.stringify(filter?.filters, null, 2);

    if (sotredFilters)
      localStorage.setItem('dropDownFiltersGeneralView', sotredFilters);
  }, [filter]);

  //Notice changes on current Line service
  useEffect(() => {
    const unsubscribe = subscribeToCurrentLineChanges(newCurrentLine => {
      setDepartment(newCurrentLine.ProdFamilyId);
      setProductName(newCurrentLine.ProdFamilyName);
    });
    return () => {
      unsubscribe();
    };
  }, []);

  

  useEffect(() => {
    setPage({ skip: 0, take: pageSize });
    setCurrentPage(1);
  }, [dateRange, sort, debouncedFilter]);

  const [filtro, setFiltro] = useState(null)

  const filterConfig = {
    text: "text",
    number: "numeric",
    boolean: "boolean",
    date: "date",
    dropdown: {
      filterCell: (props) => {
        const { field } = props;
        return (
          <CustomFilter
            {...props}
            data={users}
            field={field}
            currentFilterField={field}
            onSelectionChange={handleCustomFilterChange}
            onRemoveAll={onRemoveAll}
            selectedOptions2={currentFilter}
            selectedFilter={filtro}
            removeFilter={removeFilter}
            prevFilter={prevFilter}
            filter={dropdownFilters}  
            viewOption={viewAlias}          
          />
        );
      }
    }
  };

  const handleCustomFilterChange = (selectedOptions, currentFilterField) => {

    setFilter((prevFilter) => {
      if (!prevFilter) {
        // if there are not a existing filter creatte a new one
        return {
          logic: "or",
          filters: [
            ...selectedOptions.map((option) => ({
              field: currentFilterField,
              operator: "eq",
              value: option,
            })),
          ],
        };
      } else {
        // if there already exist a filter add current selection
        const updatedFilters = [
          ...prevFilter.filters.filter((filter) => filter.field !== currentFilterField),
          ...selectedOptions.map((option) => ({
            field: currentFilterField,
            operator: "eq",
            value: option,
          })),
        ];

        return {
          ...prevFilter,
          filters: updatedFilters,
        };
      }
    });
    setFiltro(currentFilterField);
    setCurrentFilter(selectedOptions);
    localStorage.setItem('currentFilterGeneralView', JSON.stringify(selectedOptions));
    setRemoveFilter(false);
    const allFields = filter?.filters?.map(filter => filter.field) || [];
    allFields.unshift(currentFilterField);
    const allFields2 = [...new Set(allFields)];
    setPrevFilter(allFields2);
    localStorage.setItem('currentPrevFilterGeneralView', JSON.stringify(allFields2));
    setDropdownFilters(filter?.filters);
  };


  const pageChange = (event) => {
    const targetEvent = event.targetEvent;
    const newPage = {
      skip: event.page.skip,
      take: targetEvent.value === 'All' ? totalRows : event.page.take,
    };

    setPage(newPage);
    setCurrentPage(newPage.skip / pageSize + 1);

    localStorage.setItem('pageNewOrdView', JSON.stringify(newPage));
    localStorage.setItem('currentNewOrdView', JSON.stringify(newPage.skip / pageSize + 1));
  };

  const handleFilterChange = (event) => {
    setFilter(event.filter);
  };

  const filteredUsers = filterBy(users, filter);
  const sortedUsers = orderBy(filteredUsers, sort);

  const [selectedColumns, setSelectedColumns] = useState(columns);

  //move to mf
  const selectedVisibleColumns = selectedColumns
    .filter(column => column.visible)
    .map(column => column.field);

  const visibleColumns = getVisibleColumns(selectedVisibleColumns, defaultColumnsNewOrders);

  const { data: newOrdersData, isLoading, refetch } = useNewOrdersData({
    department,
    dateColumn,
    sort,
    page,
    dateRange: { startDate: null, endDate: null },
    filter,
    viewAlias,
    CodeStringFilters,
    productName,
    token,
    debouncedFilter,
    visibleColumns,
    setToast
  });

  useEffect(() => {

    if (newOrdersData) {
      const usersWithIndex = newOrdersData.items.map((user, index) => {
        const orderDetailId = user.orderDetailId;
        const orderDetail = newOrdersExInfo.find(detail => detail.orderDetailId === orderDetailId);
        const fixedDate = new Date('Wed Dec 31 1969 18:00:00 GMT-0600 (GMT-06:00)');
  
        const truncateTime = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());
        const isSameDate = (date1, date2) => date1 && date2 && truncateTime(date1).getTime() === truncateTime(date2).getTime();
        const adjustDate = (date) => (date == null || isSameDate(date, fixedDate) ? null : date);
  
        return {
          ...user,
          rowIndex: index + 1 + page.skip,
          gdate: adjustDate(orderDetail?.gdate ? new Date(orderDetail.gdate) : null),
          endate: adjustDate(orderDetail?.endate ? new Date(orderDetail.endate) : null),
          ProductName: orderDetail?.ProductName || ''
        };
      });
  
      setScheduleData({
        TotalRows: newOrdersData.totalRows,
        Items: usersWithIndex,
      });
  
      setUsers(usersWithIndex);
      setTotalRows(newOrdersData.totalRows);
    }
    

  }, [newOrdersData, newOrdersExInfo]);  

  useEffect(() => {
    setSelectedColumns(columns);
  }, [columns], [sortedUsers]);

  const [selectedColumnFields, setSelectedColumnFields] = useState(columns.map(column => column.field));

  useEffect(() => {
    setSelectedColumnFields(columns.map(column => column.field));
  }, [columns]);

  const [openSidePanel, setOpenSidePanel] = useState(false);
  const [openForm, setOpenForm] = useState(false);
  const [editItem, setEditItem] = useState();
  const [data, setData] = useState(sortedUsers);

  const enterEditSidePanel = async (item) => {

    const updatedItem = {
      ...item,
      orderNumber: 0,
      orderNumberChecker: 0,
    };    
    setOpenSidePanel(true);
    setEditItem(updatedItem);

  };

  const enterEdit = async (item) => {

    const updatedItem = {
      ...item,
      orderNumber: 0,
      orderNumberChecker: 0,
    };

    setOpenForm(true);    
    setEditItem(updatedItem);

  };

  const handleSubmit = (event) => {
    let newData = data.map((item) => {
      if (event.item === item.item) {
        item = {
          ...event,
        };
      }
      return item;
    });
    setData(newData);
    setOpenForm(false);
  };

  const showToastError = async () => {
    setIdtoast(idtoast + 1);
    setToast({ showToast: false });
    setToast({ showToast: true, message: 'An unexpected error occurred', type: 'error' });
  };
  const showToastSuccess = async () => {
    setIdtoast(idtoast + 1);
    setToast({ showToast: false });
    setToast({ showToast: true, message: 'Order updated successfully', type: 'success' });
  };
  
  
  const { accounts } = useMsal();

  useEffect(() => {
    setToast({ showToast: false });
    setIdtoast(idtoast + 1);
    queryClient.invalidateQueries([GET_NEW_ORDERS_LIST]);
  }, [token, page.skip, page.take, sort, dateRange, debouncedFilter, department, newOrdersExInfo, CodeStringFilters]);

  useEffect(() => {
    fetchData();
  }, [newOrdersExInfo]);

  useEffect(() => {
    const formattedCodeItems = CodeStringFilters.reduce((acc, item) => {
      acc[item.description] = acc[item.description] || [];
      acc[item.description].push(`${item.Value}`);
      return acc;
    }, {});

    setCodeitemsChipsData(formattedCodeItems);
  }, [CodeStringFilters]);


  const mutation = useMutation({
    mutationFn: updateDraftHoursEstimate,
    onError: (error) => {
      showToastError();
    },
    onSuccess: (_, { newOrderDetail }) => {         
      queryClient.invalidateQueries([GET_NEW_ORDERS_LIST]);       
      setNewOrdersExInfo((prevOrders) => {
        const orderDetailExists = prevOrders.some(order => order.orderDetailId === newOrderDetail.orderDetailId);

        if (orderDetailExists) {
          
          return prevOrders.map(order => //update array if order already exists
            order.orderDetailId === newOrderDetail.orderDetailId ? newOrderDetail : order
          );
        } else {
          return [...prevOrders, newOrderDetail];
        }

      });
      
      setNewOrdersExInfo((updatedOrders) => {          
        localStorage.setItem('newOrdersExtrFields', JSON.stringify(updatedOrders, null, 2));
        return updatedOrders;
      });      
      showToastSuccess();        

    },
  });      

  const handleDraftHoursEstimate = async (values) => {  
    const gdate = new Date(values.gdate);
    const endate = new Date(values.endate);
    const fixedDate = new Date('Wed Dec 31 1969 18:00:00 GMT-0600 (GMT-06:00)');
    
    const newOrderDetail = {
      orderDetailId: values.orderDetailId,
      gdate: values.gdate ? gdate: fixedDate,
      endate: values.endate ? endate: fixedDate,
      ProductName: values.ProductName
    };

    mutation.mutate({ newOrderDetail, values, token, accounts });    
    setOpenForm(false);    
    setEditItem();
  };

  const [designerName, setName] = useState();
  const [modalVisible, setModalVisible] = useState(false);

  const handleCancelEdit = () => {
    setOpenForm(false);
    setOpenSidePanel(false);

    setEditItem();
  };

  const MyCustomLockedCell = (props) => (
    <CustomLockedCell {...props} enterEdit={enterEdit} type={'edit'} />
  );

  const handleSortChange = (e) => {
    setSort(e.sort || []);
  };

  useEffect(() => {
    setPageSize(page.take);
  }, [page]);

  const _export = React.useRef(null);
  const _grid = React.useRef();

  const _formattedDate = (() => {
    const today = new Date();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const day = today.getDate().toString().padStart(2, '0');
    const year = today.getFullYear();
    return `${month}-${day}-${year}`;
  })();

  const excelExport = () => {
    if (_export.current !== null && exportExcel === true) {

      const today = new Date();
      _export.current.save(users);
    }
  };

  useEffect(() => {
    excelExport();
    setExportExcel(false);
  }, [exportExcel === true]);


  // Zoom adjustment
  const [zoomLevel, setZoomLevel] = useState(1);
  // TODO: To use Css calc() for handle the hight instead
  const [gridHeight, setGridHeight] = useState(window.innerHeight - 270);
  const employeeRole = useEmployeeRoleContext();

  useEffect(() => {
    const handleResize = () => {
      const viewportWidth = window.innerWidth;
      const windowWidth = window.outerWidth;
      const newZoomLevel = windowWidth / viewportWidth;
      setZoomLevel(newZoomLevel);

      const newGridHeight = window.innerHeight - 270;
      setGridHeight(newGridHeight);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // Zoom adjustment

  // Columns export
  const exportColumns = columns.map((col, index) => (
    <ExcelExportColumn
      key={index}
      field={col.field}
      title={col.title}
    />
  ));
  // Columns export

  return (
    <div style={{ position: 'relative' }}>
      {(isLoading || isRefreshing) && (
        <Loader></Loader>
      )}

      <Modal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        title='Oops! It looks like this task was already taken'
        message={designerName + ' took this task'}
        type='TAKENORDER'
      />

      {toast && <Toast key={idtoast} showToast={toast.showToast} message={toast.message} type={toast.type} />}

      <div style={{ height: 'calc(100vh - 350px)', marginBottom: '15px', position: 'relative' }}>
        <ExcelExport data={(users || [])} ref={_export} fileName={`newOrders_${_formattedDate}.xlsx`}>
          {exportColumns}
        </ExcelExport>
        <Grid
          className='roboto-15-400'
          data={(users || [])}
          skip={page.skip}
          take={page.take}
          total={totalRows}
          pageable={{
            buttonCount: 4,
            type: "input",
            pageSizes: [50, 150, 200, totalRows].filter(num => num <= totalRows),
            pageSize: pageSize,
          }}
          onPageChange={pageChange}
          sortable={true}
          filterable={true}
          filter={filter}
          onFilterChange={handleFilterChange}
          resizable
          reorderable
          sort={sort}
          onSortChange={handleSortChange}
          style={{
            borderRadius: '8px',
            display: 'flex',
            margin: '15px',
            height: 'inherit'
          }}
          ref={_grid}
        >
          <GridColumn
            className='roboto-15-400'
            reorderable={false}
            sortable={false}
            filterable={false}
            editable={false}
            field="rowIndex"
            title="#"
            width="40px"
          />
          {selectedColumns
            .filter((column) => column.visible)
            .map((column) => {
              return (
                  <GridColumn
                    // NOTE: Provisional work around for hide filters
                    filterable={(column.title === 'Earliest Drafting Completion' || column.title === 'Additional Assembly Time' || column.title === 'Earliest Eng. Completion') ? false : true}
                    className='roboto-15-400'
                    sortable={true}
                    key={column.field}
                    field={column.field}
                    title={column.title}
                    headerCell={column.header}
                    width={column.minWidth}
                    filter={filterConfig[column.filterType]}
                    format="{0:d}"
                    filterCell={filterConfig[column.filterType].filterCell}
                    cell={(props) => (
                      <NewOrdersCellStyle
                        {...props} enterEdit={enterEditSidePanel}
                      />
                    )}
                  />
                );
              }
            )}
          <GridColumn
            filterable={false}
            editable={false}
            width="40px"
            locked={true}
            cell={MyCustomLockedCell}
          />
        </Grid>
        {/* </ExcelExport> */}
      </div>

      {openSidePanel && (
        <SidePanel
          cancelEdit={handleCancelEdit}          
          item={editItem}    
          disabled= {true}
        />
      )}

      {/* {openForm && (
        <EditForm
          cancelEdit={handleCancelEdit}
          onSubmit={handleSubmit}
          item={editItem}
        />
      )} */}
      {openForm && editItem && editItem.orderDetailId && (employeeRole !== READ_ONLY) &&(
        <Dialog
          onClose={handleCancelEdit}
          height={345}
          width={536}
        >
          <div style={{ padding: '8px' }} className='roboto-15-400'>
            <div className='roboto-19-700' style={{ marginBottom: '16px', display: 'flex', flexDirection: 'row', gap: '16px' }}>
              <p>{`Edit order SO: ${editItem.so}`}</p>
              {`ESOI: ${editItem.esoi}`}
              <Button
                onClick={handleCancelEdit}
                style={{
                  position: 'absolute', right: '24px',
                  width: '24px',
                  height: '24px',
                  borderRadius: '180px',
                  backgroundColor: '#F2F2F2',
                  border: 'none',
                }}> <SvgIcon icon={xIcon} color='#8D8D8D'></SvgIcon>
              </Button>
            </div>
            <Form
              initialValues={editItem}
              onSubmit={handleDraftHoursEstimate}
              render={(formRenderProps) => (
                <EditForm
                  formRenderProps={formRenderProps}
                  item={editItem}
                  cancelEdit={handleCancelEdit}
                // disabled = {disabled}
                />
              )}
            />
          </div>
        </Dialog>
      )}

    </div>
  );
}

export default NewOrdersGrid;